import React, { useMemo } from "react";
import MirsTable from "components/general/table/Table";
import { useViewport } from 'components/general/useViewPort'
import {
    isLiveStatus,
    isStartListStatus,
    isFinishedStatus
} from "helpers/status";
import CaptionTable from "components/general/table/CaptionTable";
import Status from "components/presentation/Status";
import {
    TableColumnsStartList as ColumnsStartList,
    TableColumnsLive as ColumnsLive,
    TableColumnsStartListSM as ColumnsStartListSM,
    TableColumnsLiveSM as ColumnsLiveSM,
    filterStages
} from 'components/sports/sho/components/TableColumns'
import { getEvent } from "helpers/rsc"
import LoaderSubComponent from "components/general/LoaderSubComponent";
import { filterArray } from 'helpers/utils'
import TableExpanded from "components/sports/sho/olympic/components/TableExpanded";

const getConfiguration = (data, resultStatus, breakPoint, rsc, numSeries) => {

    let configuration = {
        caption: null,
        columns: [],
        hiddenColumns: [],
        sortBy: [],
    };

    const scheduleStatus = data?.results?.schedule?.status?.code;
    let showQualMark = data?.results?.items?.some(item => item.qualificationMark);
    let isTeam = data?.results?.items?.some(item => item.itemType === 'T');


    if (!showQualMark)
        configuration.hiddenColumns.push('QualMark')
    if (getEvent(rsc).slice(0, 2) !== 'AR' && getEvent(rsc).slice(0, 2) !== 'R3')
        configuration.hiddenColumns.push('Tens')
    if (!isTeam)
        configuration.hiddenColumns.push('Expander')

    configuration.caption = <CaptionTable
        rightCol={<Status typeToPrint="result" scheduleStatus={scheduleStatus} resultStatus={resultStatus} />}
    />

    configuration.sortBy = isStartListStatus(resultStatus)
        ? [{ id: 'StartOrder', desc: false }]
        : [{ id: 'Rank', desc: false }]

    if (isStartListStatus(resultStatus)) {
        if (breakPoint === 'xs' || breakPoint === 'sm') {
            configuration.columns = ColumnsStartListSM()
        }
        else {
            configuration.columns = ColumnsStartList(numSeries)
        }
    }

    if (isLiveStatus(resultStatus) || isFinishedStatus(resultStatus)) {
        if (breakPoint === 'xs' || breakPoint === 'sm') {
            configuration.columns = ColumnsLiveSM(numSeries)
        } else {
            configuration.columns = ColumnsLive(numSeries)
        }
    }
    return configuration
}


const ShoResults = ({ data }) => {
    const { breakPoint } = useViewport();
    let resultStatus = data?.results?.status?.code;
    const rsc = data?.results?.eventUnitCode;
    let numSeries = filterStages(filterArray(data?.results?.items[0]?.extendedResults, { er_code: ['STAGE'] }))?.length

    const config = useMemo(() => getConfiguration(data, resultStatus, breakPoint, rsc, numSeries), [resultStatus, breakPoint, numSeries]);

    const renderRowSubComponent = React.useCallback(({ row }) => (
        <LoaderSubComponent component={
            <TableExpanded row={row?.original} rsc={rsc} numSeries={numSeries} />
        }
        />
    ), [resultStatus, numSeries]);

    return (
        <>
            RESULT OLIMPICO
            {data?.results?.items
                ? (
                    <>
                        < MirsTable
                            //Dato to show by row
                            data={data?.results?.items}
                            //Columnas a visualizar 
                            columns={config.columns}
                            caption={config.caption}
                            keyRow='participant-code'
                            sortable={false}
                            renderRowSubComponent={renderRowSubComponent}
                            hiddenColumns={config.hiddenColumns}
                            initialSortBy={config.sortBy}
                            colsExtendedVisible={(getEvent(rsc) === 'R3PMT-------------' && rsc.includes('FNL') && (breakPoint !== "sm" && breakPoint !== "xs")) && numSeries > 8
                                ? '10,10'
                                : '20,0'}
                            showNavExtendedData={(getEvent(rsc) === 'R3PMT-------------' && rsc.includes('FNL') && (breakPoint !== "sm" && breakPoint !== "xs")) && numSeries > 8
                                ? true
                                : false}
                            id={`mirs-table-result-${rsc}`}
                        />
                    </>
                ) : (
                    ''
                )
            }
        </>
    );
}

export default ShoResults;